var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1a1 1 0 011 1v6h6a1 1 0 110 2h-6v6a1 1 0 11-2 0v-6H2a1 1 0 010-2h6V2a1 1 0 011-1z",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05IDFDOS41NTIyOCAxIDEwIDEuNDQ3NzIgMTAgMlY4SDE2QzE2LjU1MjMgOCAxNyA4LjQ0NzcyIDE3IDlDMTcgOS41NTIyOCAxNi41NTIzIDEwIDE2IDEwSDEwVjE2QzEwIDE2LjU1MjMgOS41NTIyOCAxNyA5IDE3QzguNDQ3NzIgMTcgOCAxNi41NTIzIDggMTZWMTBIMkMxLjQ0NzcyIDEwIDEgOS41NTIyOCAxIDlDMSA4LjQ0NzcyIDEuNDQ3NzIgOCAyIDhIOFYyQzggMS40NDc3MiA4LjQ0NzcyIDEgOSAxWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgPlus as ReactComponent };